import React from 'react';
import { Container, Paper } from '@mui/material';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import { ReactFCC } from '../interface/react';

interface DefaultLayoutProps {}

const DefaultLayout: ReactFCC<DefaultLayoutProps> = ({ children }) => {
	return (
		<>
			<Header />
			<Container sx={{ px: { xs: 2, sm: 2 }, pt: { xs: 8, sm: 10 }, pb: { xs: 10, sm: 10 } }}>
				<Paper sx={{ py: 2 }} elevation={0}>
					<main>{children}</main>
				</Paper>
			</Container>
			<Footer />
		</>
	);
};

export default DefaultLayout;
